import React from 'react';
import { useTranslation } from 'react-i18next';
import { FinalFormSelect } from '@utex/ui-kit/desktop';
import { useSuggestion } from './hooks';
import { OptionView } from './Option';
import { NoOptionsMessage } from './NoOptionsMessage';
import { LoadingMessage } from './LoadingMessage';
import { OptionType } from './types';

export interface Props {
  name: string;
}

export interface Option {
  label: string;
  value: string;
  item: OptionType;
}

export const SwiftInput: React.FC<Props> = ({ name }) => {
  const { t } = useTranslation('toBank');
  const { loading, list, onChange } = useSuggestion();

  return (
    <FinalFormSelect<Option>
      name={name}
      id={name}
      label="SWIFT"
      placeholder={t('SWIFT-code of bank')}
      isSearchable
      isClearable
      isLoading={loading}
      options={list.map((item) => ({ value: item.swift, label: item.swift, item }))}
      onInputChange={onChange}
      filterOption={() => true}
      components={{
        NoOptionsMessage,
        LoadingMessage,
        Option: OptionView,
        LoadingIndicator: null,
      }}
    />
  );
};
